import { operationLoginLogList } from '@/api/company'
import moment from 'moment'
// 日志类型
const LOG_TYPE = {
  login: 24, // 登录
}
export default function (dealWithSearch) {
  return {
    configProps: {
      formData: {
        list: [
          {
            el: 'input',
            itemConfig: {
              label: '登录账号',
              prop: 'userAccount',
            },
          },
          {
            el: 'input',
            itemConfig: {
              label: '员工姓名',
              prop: 'operator',
            },
          },
          {
            el: 'date-picker',
            itemConfig: {
              label: '登录时间（365天内）',
              prop: 'time',
            },
            elConfig: {
              type: 'daterange',
              'range-separator': '至',
              'start-placeholder': '开始日期',
              'end-placeholder': '结束日期',
              'picker-options': {
                disabledDate(time) {
                  const preYear = moment().subtract(365, 'days').valueOf()
                  return time.getTime() > moment('23:59:59', 'hh:mm:ss').valueOf() || time.getTime() < preYear
                },
              },
            },
          },
        ],
        formProps: {
          model: {
            bizType: LOG_TYPE.login,
          },
        },
        dealWithSearch,
      },
      tableData: {
        columns: [
          {
            name: 'userAccount',
            columnProps: {
              label: '登录账号',
              prop: 'userAccount',
            },
          },
          {
            name: 'operator',
            columnProps: {
              label: '员工姓名',
              prop: 'operator',
            },
          },
          {
            name: 'ip',
            columnProps: {
              label: '登录IP',
              prop: 'ip',
            },
          },
          {
            name: 'operationTime',
            columnProps: {
              label: '登录时间',
              prop: 'operationTime',
            },
          },
        ],
        pagination: {
          pageSizes: [10, 20, 30, 50],
        },
        apiFn: operationLoginLogList,
      },
      isShowAllDepartment: false,
    },
  }
}
